import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import MapPinIcon from "@mui/icons-material/Place";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import BusinessIcon from "@mui/icons-material/Business";
import { Box, Button, Card, Chip, Divider, IconButton, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, ListItemAvatar, Avatar } from "@mui/material";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue } from "../../assets/helpers";
import AddContactInfo from "../common/AddContactInfo";
import AddPhoneNumberModal from "../common/AddPhoneNumberModal";
import AddTradeModal from "../common/AddTradeModal";
import AddWebsiteModal from "../common/AddWebsiteModal";
import DeleteConfirmation from "../common/DeleteConfirmation";
import Loader from "../../common/Loader";
import { DELETE_COMPANY_TRADE, FETCH_CURRENT_COMPANY_MERGE_MAPPING } from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";

const ManufactureAboutSection = ({
  manufactureDetails,
  tradeList,
  manufactureAddress,
  onTradesSaveSuccessfully,
  onManufactureDetailsSaveSuccessfully,
  onManufactureAddressSaveSuccessfully,
  isVerified = false,
  color = ""
}) => {
  const { loginData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Manufacturers || {};

  const {
    TEXT_ABOUT_INFO = English.Manufacturers.TEXT_ABOUT_INFO,
    TEXT_ADD_EMAIL = English.Manufacturers.TEXT_ADD_EMAIL,
    TEXT_TRADE_COMPONY = English.Manufacturers.TEXT_TRADE_COMPONY,
    TEXT_ADD_WEBSITE = English.Manufacturers.TEXT_ADD_WEBSITE,
    TEXT_ADD_PHONE_NUMBER = English.Manufacturers.TEXT_ADD_PHONE_NUMBER,
    BUTTON_ADD_ADDRESS_AND_CONTACT = English.Manufacturers.BUTTON_ADD_ADDRESS_AND_CONTACT,
    BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT = English.Manufacturers.BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT,
    TEXT_ADD_CONTACT_INFO = English.Manufacturers.TEXT_ADD_CONTACT_INFO,
    TEXT_ADD_ADDRESS_TITLE = English.Manufacturers.TEXT_ADD_ADDRESS_TITLE,
    TEXT_DELETE_MANUFACTURERS_TARDES = English.Manufacturers.TEXT_DELETE_MANUFACTURERS_TARDES,
    TEXT_DELETE_COMPANY_TARDES_DEC = English.Manufacturers.TEXT_DELETE_COMPANY_TARDES_DEC
  } = LanguageData || {};

  const [showAddTradesModal, setShowAddTradeOpenModal] = useState(false);
  const [loading] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(0);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [basicDetailsModalType, setBasicDetailsModalType] = useState(null);
  const [mergeMapping, setMergeMapping] = useState(null);
  const [showAllChildCompaniesModal, setShowAllChildCompaniesModal] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleMergeMappingNavigate = (mapping) => {
    if (!mapping?.id) return;
    if (mapping.manufacturer) {
      navigate(`/manufacture/${mapping.id}`);
    } else {
      navigate(`/company/${mapping.id}`);
    }
  };

  useEffect(() => {
    if (manufactureDetails?.id) {
      fetchMergeMapping();
    }
  }, [manufactureDetails?.id]);

  const fetchMergeMapping = async () => {
    try {
      const payload = {
        CompanyId: Number(manufactureDetails.id),
        UserId: currentUserId
      };
      const res = await Postrequestcall(FETCH_CURRENT_COMPANY_MERGE_MAPPING, payload, loginData?.accessToken);
      if (res?.data?.data && res?.data?.data?.mergeList?.length > 0) {
        setMergeMapping(res.data.data);
      } else {
        setMergeMapping(null);
      }
    } catch (error) {
      console.error("fetchMergeMapping-> Error:", error);
    }
  };

  const onTradeItemClick = (id) => {
    if (!id) return;
    setSelectedTradeId(id);
    setConfirmDeleteModalOpen(true);
  };

  const handleWebRedirect = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl.hostname}`;
      window.open(`http://${baseUrl}`, "_blank");
    } catch (error) {
      window.open(`http://${inputUrl}`, "_blank");
    }
  };

  const extractBaseURL = (inputUrl) => {
    try {
      if (!inputUrl) return "";

      let url = inputUrl.trim();

      // Add protocol if missing
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }

      const parsedUrl = new URL(url);

      return parsedUrl.hostname.replace(/^www\./, "");
    } catch (error) {
      console.error("extractBaseURL-> Error:", error);
      return inputUrl;
    }
  };

  const handleDeleteTrade = async () => {
    try {
      const obj = {
        UserId: currentUserId,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            TradeId: selectedTradeId,
            CompanyId: manufactureDetails.id
          }
        ]
      };
      const res = await Postrequestcall(DELETE_COMPANY_TRADE, obj, loginData?.accessToken);
      if (res.status === 201) {
        onTradesSaveSuccessfully();
      } else {
        console.log("handleDeleteTrade-> Error When Deleting Company Trade");
      }
    } catch (error) {
      console.error("handleDeleteTrade-> Error When Deleting Company Trade: ", error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const hasNoAddressOrPhone =
    (!manufactureDetails?.address || manufactureDetails.address === "") &&
    (!manufactureDetails?.phone || manufactureDetails.phone === "");

  const allMappingItems = mergeMapping ? [mergeMapping, ...(mergeMapping.mergeList || [])] : [];
  const childMappingObjs = allMappingItems.filter(item => item.status === "Child");

  const isMappingEmpty = !mergeMapping || (mergeMapping.status === "Parent" && childMappingObjs.length === 0);

  const isNOInfo =
    tradeList.length === 0 &&
    hasNoAddressOrPhone &&
    !manufactureDetails?.webSite &&
    isMappingEmpty;

  const renderNoManufacturer = () => {
    const emptyText = isVerified ? "No data added by admin" : "No data added";
    const emptySubText = isVerified
      ? "This section is managed by the manufacturer admin."
      : "Add manufacturer's details to make this section complete.";
    return (
      isNOInfo && (
        <Box
          sx={{
            mt: 1.5,
            mb: 1,
            px: 2,
            py: 2,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "grey.200",
            bgcolor: isVerified ? "primary.50" : "grey.50"
          }}>
          <Stack direction="row" alignItems="center" spacing={1.5} justifyContent="center">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: isVerified ? "primary.100" : "grey.200",
                color: isVerified ? "primary.main" : "text.secondary",
                flexShrink: 0
              }}>
              <InfoOutlinedIcon sx={{ fontSize: 20 }} />
            </Box>
            <Stack spacing={0.25} sx={{ textAlign: "left" }}>
              <Typography variant="body2" fontWeight={700} color="text.primary">
                {emptyText}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {emptySubText}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      )
    );
  };

  const renderMergeMapping = () => {
    if (!mergeMapping) return null;
    const allMappingItemsLocal = [mergeMapping, ...(mergeMapping.mergeList || [])];
    const parentMappingObj = allMappingItemsLocal.find(item => item.status === "Parent") || mergeMapping;
    const childMappingObjsLocal = allMappingItemsLocal.filter(item => item.status === "Child");
    const isCurrentChild = mergeMapping?.status === "Child";
    const isCurrentParent = mergeMapping?.status === "Parent";

    if (isCurrentParent && childMappingObjsLocal.length === 0) return null;
    if (isCurrentChild && !parentMappingObj) return null;

    return (
      <Box sx={{ 
        mt: 3, 
        mb: 2, 
        p: 2.5, 
        borderRadius: 3, 
        bgcolor: "rgba(25, 118, 210, 0.04)", 
        border: "1px solid rgba(25, 118, 210, 0.12)",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        transition: "all 0.3s ease",
        '&:hover': { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <BusinessIcon sx={{ color: BIBlue, fontSize: 20 }} />
          <Typography variant="subtitle2" sx={{ color: BIBlue, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>
            {isCurrentChild ? "Parent Company" : `Child Companies (${childMappingObjsLocal.length})`}
          </Typography>
        </Box>
        
        {isCurrentChild && (
          <Box>
            <Chip 
              label={parentMappingObj?.name} 
              onClick={() => handleMergeMappingNavigate(parentMappingObj)}
              sx={{ 
                fontWeight: 600, 
                bgcolor: "white",
                border: `1px solid ${BIBlue}`,
                color: BIBlue,
                py: 0.5,
                height: 'auto',
                '& .MuiChip-label': { display: 'block', whiteSpace: 'normal', padding: '6px 12px' },
                boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
                cursor: "pointer",
                transition: "all 0.2s",
                '&:hover': { bgcolor: BIBlue, color: "white" }
              }}
            />
          </Box>
        )}
        
        {isCurrentParent && (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            {childMappingObjsLocal.slice(0, 3).map((mapping) => (
              <Chip 
                key={mapping.id} 
                label={mapping.name} 
                onClick={() => handleMergeMappingNavigate(mapping)}
                sx={{ 
                  bgcolor: "white", 
                  border: "1px solid #e0e0e0", 
                  fontWeight: 500,
                  py: 0.5,
                  height: 'auto',
                  '& .MuiChip-label': { display: 'block', whiteSpace: 'normal', padding: '6px 12px' },
                  boxShadow: "0px 1px 3px rgba(0,0,0,0.04)",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  '&:hover': { borderColor: BIBlue, color: BIBlue, bgcolor: "rgba(25, 118, 210, 0.04)" }
                }} 
              />
            ))}
            {childMappingObjsLocal.length > 3 && (
              <Chip 
                label={`+${childMappingObjsLocal.length - 3} more`} 
                onClick={() => setShowAllChildCompaniesModal(true)}
                sx={{ 
                  cursor: "pointer", 
                  bgcolor: BIBlue, 
                  color: "white", 
                  fontWeight: 600,
                  py: 0.5,
                  height: 'auto',
                  transition: "all 0.2s",
                  boxShadow: "0px 2px 4px rgba(25, 118, 210, 0.25)",
                  '&:hover': { bgcolor: "#1565c0" }
                }}
              />
            )}
          </Box>
        )}
      </Box>
    );
  };

  const renderTradeList = () => {
    return (
      (tradeList?.length !== 0 || !pathname.includes("proxySite")) && (
        <>
          {tradeList?.length !== 0 ? (
            <Stack
              style={{
                marginTop: "2%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px 10px",
                paddingBottom: isVerified ? "0" : "15px"
              }}
              direction="row"
              spacing={0}>
              {tradeList
                ?.sort(
                  (a, b) =>
                    a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
                    a.tradeName
                      ?.trim()
                      .toLowerCase()
                      .localeCompare(b.tradeName?.trim().toLowerCase())
                )
                .map((item, index) => {
                  return (
                    <Chip
                      size={isVerified ? "small" : "medium"}
                      key={index.toString()}
                      label={item.tradeName?.trim()}
                      style={{
                        cursor: !pathname.includes("proxySite") ? "pointer" : "default",
                        backgroundColor:
                          item?.tradeType?.toLowerCase() === "main" ? BIBlue : "null",
                        color: item?.tradeType?.toLowerCase() === "main" ? "white" : "null",
                        borderRadius: isVerified ? "5px" : "16px"
                      }}
                      onClick={() => {
                        // if (!pathname.includes("proxySite")) {
                        //   onTradeItemClick(item?.tradeId ?? 0);
                        // } else {
                        //   return;
                        // }
                      }}></Chip>
                  );
                })}
              {!pathname.includes("proxySite") && !isVerified && (
                <>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => {
                      setShowAddTradeOpenModal(true);
                    }}
                    style={{ backgroundColor: BIBlue, color: "white" }}>
                    <AddIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                  {isVerified && <Divider />}
                </>
              )}
            </Stack>
          ) : (
            !pathname.includes("proxySite") &&
            !isVerified && (
              <>
                <Stack
                  direction="row"
                  paddingBottom={isVerified ? 0 : 2}
                  style={{ marginTop: isVerified ? "0" : "10px" }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setShowAddTradeOpenModal(true);
                    }}
                    style={{ borderRadius: "30px" }}>
                    {TEXT_TRADE_COMPONY}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  const renderEmail = () => {
    return (
      (!pathname.includes("proxySite") || manufactureDetails?.email) &&
      (manufactureDetails?.email ? (
        <>
          <Stack direction="row" spacing={2}>
            <EmailIcon color="primary" sx={{ color: color, textDecoration: "none" }} />
            <span
              style={{
                color: isVerified === false ? BIBlue : "black",
                cursor: "pointer"
              }}>
              {manufactureDetails?.email}
            </span>
          </Stack>
          {isVerified && <Divider />}
        </>
      ) : (
        <>
          {!isVerified && (
            <>
              <Stack direction="row" alignItems={"center"} spacing={2}>
                <EmailIcon color="primary" sx={{ textDecoration: "none" }} />
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setBasicDetailsModalType("email");
                  }}
                  style={{ width: "100%" }}>
                  {TEXT_ADD_EMAIL}
                </Button>
              </Stack>
              {isVerified && <Divider />}
            </>
          )}
        </>
      ))
    );
  };

  const renderWebsite = () => {
    return (
      (!pathname.includes("proxySite") || manufactureDetails?.webSite) && (
        <>
          {manufactureDetails?.webSite ? (
            <>
              <Stack direction="row" spacing={2}>
                <PublicIcon color="primary" sx={{ color: color }} />
                <span
                  style={{
                    color: BIBlue,
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => handleWebRedirect(manufactureDetails?.webSite)}>
                  {extractBaseURL(manufactureDetails?.webSite)}
                </span>
              </Stack>
              {isVerified && <Divider />}
            </>
          ) : (
            !isVerified && (
              <>
                <Stack direction="row" alignItems={"center"} spacing={2}>
                  <PublicIcon color="primary" sx={{ color: color }} />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("website");
                    }}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_WEBSITE}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  const normalizeAddressRecord = (rec) => ({
    address: rec?.address || rec?.Address || "",
    city: rec?.city || rec?.City || "",
    province: rec?.province || rec?.Province || "",
    postalCode: rec?.postalCode || rec?.PostalCode || "",
    country: rec?.country || rec?.Country || "",
    contactPerson: rec?.contactPerson || rec?.ContactPerson || "",
    phone: rec?.phone || rec?.Phone || "",
    email: rec?.email || rec?.Email || ""
  });

  const formatAddressString = (rec) =>
    [rec?.address, rec?.city, rec?.province, rec?.postalCode, rec?.country]
      .filter((part) => part && String(part).trim() !== "")
      .join(", ");

  const renderContactInfo = () => {
    const website = manufactureDetails?.webSite;
    const phone = manufactureDetails?.phone;
    const addressRecords = (manufactureAddress || []).map(normalizeAddressRecord);
    const addressStrings = addressRecords.filter(
      (rec) => !rec.contactPerson && !rec.phone && !rec.email && formatAddressString(rec)
    );

    const hasContactInfo =
      website || phone || addressRecords.length > 0 || !pathname?.includes("proxySite");

    if (!hasContactInfo) {
      return null;
    }

    const showAddButton = !pathname?.includes("proxySite") && !isVerified;

    const renderRecordCard = (rec, i) => (
      <Stack
        key={i}
        direction="column"
        spacing={0.75}
        sx={{
          mt: 1,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "grey.200"
        }}>
        {formatAddressString(rec) && (
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <MapPinIcon color="primary" sx={{ color: color, mt: 0.25 }} fontSize="small" />
            <Typography variant="body2">{formatAddressString(rec)}</Typography>
          </Stack>
        )}
        {rec.contactPerson && (
          <Stack direction="row" spacing={2} alignItems="center">
            <PersonIcon color="primary" sx={{ color: color }} fontSize="small" />
            <Typography variant="body2">{rec.contactPerson}</Typography>
          </Stack>
        )}
        {rec.phone && (
          <Stack direction="row" spacing={2} alignItems="center">
            <PhoneIcon color="primary" sx={{ color: color }} fontSize="small" />
            <a href={`tel:${rec.phone}`} style={{ color: "inherit", textDecoration: "none" }}>
              <Typography variant="body2">{rec.phone}</Typography>
            </a>
          </Stack>
        )}
        {rec.email && (
          <Stack direction="row" spacing={2} alignItems="center">
            <MailIcon color="primary" sx={{ color: color }} fontSize="small" />
            <a href={`mailto:${rec.email}`} style={{ color: "inherit", textDecoration: "none" }}>
              <Typography variant="body2">{rec.email}</Typography>
            </a>
          </Stack>
        )}
      </Stack>
    );

    return (
      <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid", borderColor: "divider" }}>
        <Stack spacing={1.5}>
          {phone && !addressRecords.length && (
            <Stack direction="row" spacing={2} alignItems="center">
              <PhoneIcon color="primary" sx={{ color: color }} fontSize="small" />
              <a href={`tel:${phone}`} style={{ color: "inherit", textDecoration: "none" }}>
                <Typography variant="body2">{phone}</Typography>
              </a>
            </Stack>
          )}

          {addressRecords.length > 0 ? (
            <>
              {addressRecords.map((rec, i) => renderRecordCard(rec, i))}
              {showAddButton && (
                <Box sx={{ textAlign: "end" }}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("address");
                    }}>
                    {BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT}
                  </Button>
                </Box>
              )}
            </>
          ) : addressStrings.length > 0 ? (
            <>
              {addressStrings.map((rec, i) => (
                <Stack key={i} direction="row" spacing={2} alignItems="flex-start">
                  <MapPinIcon color="primary" sx={{ color: color, mt: 0.25 }} fontSize="small" />
                  <Typography variant="body2">{formatAddressString(rec)}</Typography>
                </Stack>
              ))}
              {showAddButton && (
                <Box sx={{ textAlign: "end" }}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("address");
                    }}>
                    {BUTTON_ADD_ADDRESS_AND_CONTACT}
                  </Button>
                </Box>
              )}
            </>
          ) : (
            showAddButton && (
              <Stack direction="row" alignItems={"center"} spacing={2}>
                <MapPinIcon color="primary" sx={{ color: color }} fontSize="small" />
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setBasicDetailsModalType("address");
                  }}
                  style={{ width: "100%" }}>
                  {TEXT_ADD_CONTACT_INFO}
                </Button>
              </Stack>
            )
          )}
        </Stack>
      </Box>
    );
  };

  // Render verified layout
  const renderVerifiedLayout = () => (
    <Card sx={{ p: "10px" }}>
      <Typography>{manufactureDetails?.description}</Typography>
      {renderNoManufacturer()}
      {renderMergeMapping()}
      <Stack gap={2}>
        {renderTradeList()}
        {renderEmail()}
        {renderWebsite()}
        {renderContactInfo()}
      </Stack>
    </Card>
  );

  // Render unverified layout
  const renderUnverifiedLayout = () => (
    <Card className="pagelist-content" sx={{ p: 2, height: "100%" }}>
      <Typography variant="h6">{TEXT_ABOUT_INFO}</Typography>
      {renderNoManufacturer()}
      {renderMergeMapping()}
      {renderTradeList()}
      <Stack gap={2}>
        {renderWebsite()}
        {renderContactInfo()}
      </Stack>
    </Card>
  );

  return (
    <>
      {/* Conditional rendering based on verification status */}
      {console.log("manufactureAddress============", manufactureAddress)}
      {isVerified ? renderVerifiedLayout() : renderUnverifiedLayout()}

      {/* Common Modals */}
      {showAddTradesModal && (
        <AddTradeModal
          open={showAddTradesModal}
          onClose={() => {
            setShowAddTradeOpenModal(false);
          }}
          alreadyTradesSelected={tradeList}
          mainId={manufactureDetails?.id}
          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "website" && (
        <AddWebsiteModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
          {...(!isVerified && { onSaveClick: () => {} })}
        />
      )}

      {basicDetailsModalType === "phone" && (
        <AddPhoneNumberModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "email" && (
        <AddPhoneNumberModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
        />
      )}

      {confirmDeleteModalOpen && (
        <DeleteConfirmation
          open={confirmDeleteModalOpen}
          onClose={() => setConfirmDeleteModalOpen(false)}
          headerText={TEXT_DELETE_MANUFACTURERS_TARDES}
          secondaryText={TEXT_DELETE_COMPANY_TARDES_DEC}
          onBadgeClick={handleDeleteTrade}
        />
      )}

      {basicDetailsModalType === "address" && (
        <AddContactInfo
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureAddressSaveSuccessfully}
        />
      )}

      <Dialog 
        open={showAllChildCompaniesModal} 
        onClose={() => setShowAllChildCompaniesModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        {(() => {
          const allMappingItemsLocal = mergeMapping ? [mergeMapping, ...(mergeMapping.mergeList || [])] : [];
          const childMappingObjsLocal = allMappingItemsLocal.filter(item => item.status === "Child");
          return (
            <>
              <DialogTitle sx={{ pb: 1 }}>
                <Typography variant="h6" fontWeight="bold">Child Companies ({childMappingObjsLocal?.length})</Typography>
              </DialogTitle>
              <DialogContent dividers sx={{ p: 0 }}>
                <List sx={{ pt: 0, pb: 0 }}>
                  {childMappingObjsLocal?.map((mapping, index) => (
                    <ListItem 
                      key={mapping.id} 
                      onClick={() => handleMergeMappingNavigate(mapping)}
                      sx={{ 
                        borderBottom: index !== childMappingObjsLocal.length - 1 ? "1px solid #f0f0f0" : "none",
                        px: 3,
                        py: 1.5,
                        cursor: "pointer",
                        '&:hover': { backgroundColor: "#f9f9f9" }
                      }}
                    >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "#e3f2fd", color: BIBlue }}>
                    <BusinessIcon />
                  </Avatar>
                </ListItemAvatar>
                  <ListItemText 
                    primary={mapping.name} 
                    primaryTypographyProps={{ fontWeight: 500 }}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={() => setShowAllChildCompaniesModal(false)} variant="contained" color="primary" disableElevation sx={{ borderRadius: 2 }}>
              Close
            </Button>
          </DialogActions>
            </>
          );
        })()}
      </Dialog>
    </>
  );
};

export default ManufactureAboutSection;
